<template lang="jade">
  .container
    .row
      .welcome_main.col-md-12
        header.welcome_title_bar.main_title_bar.col-md-12
          h1 Welcome , {{user.name}}
        section.steps_content.col-md-12
          h2.warning You have no devices online yet
          h2 To add some device, you can follow the steps below:
          ul.steps.clearfix
            li 1.
              span.bold &nbsp;Click
              span.link(v-on:click="handleAddDevice") &nbsp;Add Device
              |&nbsp;or Click your name on the right top corner and click 'Add device'
            li 2. Enter installer ID, Associate Code, then click apply
            li 3. Enjoy operating your device!!!
</template>

<script>
import { getUser } from 'src/Service.js'
export default{
  data () {
    return {
      user: {}
    }
  },
  ready () {
  },
  computed: {
  },
  asyncData () {
    // use it to get user data when the App is running
    this.user = getUser()
  },
  methods: {
    handleAddDevice () {
      this.$root.$broadcast('add_device', this.user)
      // call the root , is App.vue to broadcast 'add_device'
    }
  },
  events: {
    user (uid, user) {
      // use it to get user data when refresh the App
      this.user = user
      this.user.uid = uid
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~__vendor_variables_scss__";
  @import "~sass/_breakpoint.scss";
  .warning{
    @include breakpoint(xxs) {
      padding:5px 0px;
    }
  }
  .welcome_title_bar h1 {
    padding-left: 0;
  }
  .steps{
    li {
      height:34px;
      line-height:34px;
      float: left;
      clear: left;
      border-bottom:1px solid $pri_gray;
      padding:5px;
      @include breakpoint(xxs){
        height:auto;
      }
    }
    .bold{
      font-weight:900;
    }
    .link{
      cursor:pointer;
      text-decoration:underline;
    }
  }
</style>



// WEBPACK FOOTER //
// Welcome.vue?33b16dd6